//  import Vue from 'vue'
// import lib from '@/library'
// import config from '@/config'
import store from '@/store'
// import Branding from '@/components/mixins/Branding'

export default {
  data () {
    return {
    }
  },

  components: {},

  computed: {
    derivativeSelectionsLW () {
      let selectionsLW = []
      if (this.currentBetSlipState > 1) {
        return selectionsLW
      }
      let props = ['idfoselection', 'idfomarket', 'currenthandicap', 'currentpricedown', 'currentpriceup', 'price', 'activepricetypes', 'idfoselectionsuspensiontype']
      // , 'isclosed', 'istradable', 'idfobolifestate'
      for (let derivateSelections of this.derivativeSelections) {
        let lws = store.getters['sbBetslipState/getSelectionById'](this.id, derivateSelections)
        if (lws) {
          let lwsCore = {}
          for (let p of props) {
            if (p === 'activepricetypes' && typeof lws[p] === 'string') {
              lwsCore[p] = lws[p]
              lwsCore.pricetypecsv = lws[p]
              lwsCore.csvpricetypes = lws[p].split(',')
              store.commit('sbBetslipState/setPriceType', lwsCore)
            } else {
              lwsCore[p] = lws[p]
            }
          }
          selectionsLW.push(lwsCore)
        }
      }
      return selectionsLW
    }
  },

  methods: {
  },

  created () {
  },

  mounted () {
  },

  watch: {
    derivativeSelectionsLW: {
      immediate: true,
      handler (newVal, oldVal) {
        // console.log('Watch derivativeSelectionsLW')
        // console.log('oldVal: ', JSON.stringify(oldVal))
        // console.log('newVal: ', JSON.stringify(newVal))
        // let propsToUpdate = ['currenthandicap', 'currentpricedown', 'currentpriceup', 'price']
        let propsNotToUpdate = ['idfoselection', 'idfomarket']
        if (newVal && newVal.length) {
          for (let s of newVal) {
            let derivativeSelection = this.derivativeSelections.find(bps => bps.idfoselection === s.idfoselection)
            if (derivativeSelection) {
              // for (let prop of propsToUpdate) {
              for (let prop in s) {
                if (!propsNotToUpdate.includes(prop)) {
                  derivativeSelection[prop] = s[prop]
                  if (prop === 'currenthandicap') {
                    derivativeSelection.currentmatchhandicap = s.currenthandicap
                  }
                }
              }
            }
          }
        }
      }
    }
  },

  destroyed () {
  }
}



// WEBPACK FOOTER //
// ./src/components/sports/BetSlipV2/mixins/derivativeLW.js